import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { computed, reactive, ref, watch } from 'vue';
import { useParentNodeRender, useLeafNodeRender } from './customRender';
import { useKpiTableStaticColumns } from './useKpiTableStaticColumns';
export const zhNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
export const columnWidths = [160, 180, 200, 220, 240, 260];

/**
 * 绩效指标表格列配置生成器
 * @param props
 * @returns columns 表格列配置
 */
export const useKpiTableColumns = props => {
  const defaultFields = {
    level1_name: 1,
    // 第一级指标名称
    level2_name: 1,
    // 第二级指标名称
    code: 0,
    // 第三级指标编码
    name: 1,
    // 第三级指标名称
    value: 1,
    // 指标值
    summary: 1,
    // 指标值说明
    explain: 0,
    // 指标解释
    std: 0,
    // 绩效标准
    basis: 0,
    // 指标依据
    scoreStd: 0 // 评分标准
  };
  const editable = ref(props.editable || false);
  const layers = ref(props.layers || 3);
  const extraColumns = ref(props.extraColumns || []);
  const fields = reactive(props.fields || {});
  const staticColumns = useKpiTableStaticColumns(extraColumns.value || []);
  const useColumnCustomCell = col => row => {
    const {
      parents = []
    } = row || {};
    const {
      rowSpan = 1
    } = parents[col] || {};
    return {
      rowSpan
    };
  };
  const srcColumns = ref([]);
  const createColumns = nLayer => {
    const tempColumns = [];
    for (let i = 1; i < nLayer; i++) {
      tempColumns.push({
        title: `${zhNumbers[i]}级指标`,
        dataIndex: ['parents', `${i - 1}`, 'data', 'name'],
        field: `level${i}_name`,
        width: columnWidths[i - 1],
        align: 'center',
        resizable: true,
        customCell: useColumnCustomCell(i - 1),
        customRender: useParentNodeRender({
          editable: editable.value,
          col: i - 1,
          onAction: props.onAction
        })
      });
    }
    tempColumns.push({
      title: '编码',
      field: 'code',
      width: 80,
      align: 'center',
      resizable: true,
      dataIndex: ['data', 'code']
    }, {
      title: `${zhNumbers[nLayer]}级指标`,
      dataIndex: ['data', 'name'],
      field: 'name',
      width: 210,
      resizable: true,
      align: 'center',
      customRender: useLeafNodeRender({
        editable: editable.value,
        onAction: props.onAction
      })
    }, ...staticColumns);
    srcColumns.value = tempColumns;
  };
  watch(() => layers.value, val => {
    createColumns(unref(val));
  }, {
    immediate: true
  });
  const displayFields = computed(() => {
    const tmpColumns = {
      ...defaultFields
    };
    Object.assign(tmpColumns, fields);
    return tmpColumns;
  });
  const columns = computed(() => {
    return srcColumns.value.filter(col => {
      return displayFields.value[col.field] === 'undefined' || displayFields.value[col.field] === 1;
    });
  });
  return {
    columns
  };
};